module.exports = __webpack_public_path__ + "resources/img/img_confluent_platform1.c7ecec78c568ac43be5ad6e7702b1199.png";